import type { ActionType } from "typesafe-actions";
import { createReducer } from "typesafe-actions";

import {
    clearAiAgentChatState,
    clearMessages,
} from "app/pages/sales-intelligence/modules/ai-agent/store/chat/action-creators";

import * as actions from "./action-creators";
import type { LeadGeneratorState } from "./types";

const INITIAL_STATE: LeadGeneratorState = {
    contextualSuggestions: {
        data: null,
        error: null,
    },
    outputFilters: null,
    processedMessages: {},
    numberOfGeneratedQueries: 0,
};

const leadGeneratorReducer = createReducer<LeadGeneratorState, ActionType<typeof actions>>(INITIAL_STATE)
    .handleAction(
        actions.setContextualSuggestions,
        (state: LeadGeneratorState, { payload }): LeadGeneratorState => ({
            ...state,
            contextualSuggestions: {
                ...state.contextualSuggestions,
                data: payload,
                error: null,
            },
        }),
    )
    .handleAction(
        actions.setOutputFilters,
        (state: LeadGeneratorState, { payload }: ReturnType<typeof actions.setOutputFilters>): LeadGeneratorState => ({
            ...state,
            outputFilters: payload,
        }),
    )
    .handleAction(
        actions.setPreprocessedMessageData,
        (
            state: LeadGeneratorState,
            { payload }: ReturnType<typeof actions.setPreprocessedMessageData>,
        ): LeadGeneratorState => ({
            ...state,
            processedMessages: {
                ...state.processedMessages,
                [payload.messageId]: payload,
            },
        }),
    )
    .handleAction([clearAiAgentChatState, clearMessages], (): LeadGeneratorState => INITIAL_STATE)
    .handleAction(
        actions.incrementGeneratedQueries,
        (state: LeadGeneratorState): LeadGeneratorState => ({
            ...state,
            numberOfGeneratedQueries: state.numberOfGeneratedQueries + 1,
        }),
    )
    .handleAction(
        actions.resetGeneratedQueries,
        (state: LeadGeneratorState): LeadGeneratorState => ({
            ...state,
            numberOfGeneratedQueries: 0,
        }),
    );
export default leadGeneratorReducer;
